import type { CredentialType } from "@/features/credentials/models/credential";
import { FieldDescription, Tabs, TabsList, TabsTrigger } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

const CREDENTIAL_TYPE_OPTIONS: CredentialType[] = ["ENTITY", "VENUE", "ALL"];

export function CredentialTypeSelector({
  value,
  onChange,
  disabled = false,
}: {
  value: CredentialType;
  onChange: (value: CredentialType) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <Tabs
        value={value}
        onValueChange={(nextValue) => {
          if (!disabled) {
            onChange(nextValue as CredentialType);
          }
        }}
      >
        <TabsList className="w-full">
          {CREDENTIAL_TYPE_OPTIONS.map((type) => (
            <TabsTrigger key={type} value={type} className="flex-1" disabled={disabled}>
              {t(`credentials.create.types.${type}.label`)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <FieldDescription>{t(`credentials.create.types.${value}.description`)}</FieldDescription>
    </div>
  );
}
